<template>
    <div>
        <div class="page_title">
          <span class="page_title_comment mplus2p-m spacing1-2 noiseblack">{{$t('update_password')}}</span>
        </div>
      <form @submit.prevent="doConfirm" name="form" class="ml-4">
        <div class="form-group input text-left" :class="{ invalid: $v.currentpassword.$error && $v.currentpassword.$dirty}" style="margin-top: 20px;">
          <label class="mplus2p-m spacing1-2 black signlabel">{{$t('current_password')}}
            <span style="color: red;">*</span>
          </label>
          <input 
                :placeholder="$t('passwordPlaceholder')" 
                type="password" 
                class="form-control peditboxes peditinput" 
                style="margin-left:0px" 
                name="currentpassword" 
                v-model="$v.currentpassword.$model" 
                autofocus/>
            <div class="help-block" v-if="!$v.currentpassword.minLength && $v.currentpassword.$dirty">{{$t('r_input_password_validation')}}</div>
          <div class="help-block" v-if="!$v.currentpassword.req && $v.currentpassword.$dirty">{{$t('required_filed')}}</div>
        </div>

        <div class="form-group input text-left" :class="{ invalid: $v.password.$error && $v.password.$dirty }" style="margin-top: 20px;">
          <label class="mplus2p-m spacing1-2 black signlabel">{{$t('l_password')}}
            <span style="color: red;">*</span>
          </label>
          <input 
              :placeholder="$t('passwordPlaceholder')" 
              type="password" 
              class="form-control  peditboxes peditinput" 
              style="margin-left:0px"  
              name="password" 
              v-model="$v.password.$model" 
              autofocus/>
          <div class="help-block" v-if="!$v.password.minLength && $v.password.$dirty">{{$t('r_input_password_validation')}}</div>
          <div class="help-block" v-if="!$v.password.req && $v.password.$dirty">{{$t('required_filed')}}</div>
        </div>

        <div class="form-group input text-left" :class="{ invalid: $v.cPassword.$error && $v.cPassword.$dirty}" style="margin-top: 20px;">
          <label class="mplus2p-m spacing1-2 black signlabel">{{$t('r_c_password')}}
            <span style="color: red;">*</span>
          </label>
          <input 
              :placeholder="$t('passwordPlaceholder')" 
              type="password" 
              class="form-control peditboxes peditinput" 
              style="margin-left:0px"  
              name="password" 
              v-model="$v.cPassword.$model" 
              autofocus/>
          <div class="help-block" v-if="!$v.cPassword.sameAsPassword && $v.cPassword.$dirty">{{$t('r_c_input_password_validation')}}</div>
          <div class="help-block" v-if="!$v.cPassword.req && $v.cPassword.$dirty">{{$t('required_filed')}}</div>
        </div>

        <div class="form-group" style="margin-top: 40px;">
          <button class="btn bluebtn mplus2p-r spacing1-2 regnext_btn" style="font-size: 1.125rem; font-weight: bold;">{{$t('change_password')}}
          </button>
        </div>
      </form>
    </div>
</template>

<script>
if (typeof jQuery === "undefined") {
  if (typeof require === "function") {
    window.jQuery = window.$ = require("jquery");
  } else {
    window.jQuery = $;
  }
}
import axios from "axios";
import { validationMixin } from "vuelidate";
import {
  required,
  maxLength,
  minLength,
  sameAs
} from "vuelidate/lib/validators";
export default {
  mixins: [validationMixin],

  validations: {
    currentpassword: { req: required, minLength: minLength(6) },
    password: { req: required, minLength: minLength(6) },
    cPassword: { req: required, sameAsPassword: sameAs("password") },
  },
  data() {
    return {
      currentpassword: "",
      password: "",
      cPassword: ""
    }
  },
  methods: {
     doConfirm() {
      this.$emit("stopLoding",true);
      const thisVue = this;
      const formData = {
        current_password: this.currentpassword,
        password: this.password,
        password_confirmation: this.cPassword
      };

      this.$v.$touch()
      if(this.$v.$invalid){
        this.$emit("stopLoding", false);
        return
      } 
      else{
      axios
        .post(
          "change-password?token=" + localStorage.getItem("token"),
          formData,
          {
            headers: { "X-localization": localStorage.getItem("lan") }
          }
        )
        .then(res => {
          if (res.data.errors) {
            this.password= null;
            this.cPassword = null;
            this.$v.$reset();
            if (res.data.errors) {
              if (res.data.errors[0].message) {
                this.$toaster.error(thisVue.$t("error_changing_password"));
              }
            }
             this.$emit("stopLoding",  false);
          } else {
            this.$toaster.success(thisVue.$t("password_updated"));
            this.password= null;
            this.cPassword = null;
            this.$v.$reset();
            this.$emit("stopLoding",  false);
          }
        })
        .catch(() => {
          this.$toaster.error(thisVue.$t("err_network"));
        });

      this.$v.$reset();
      this.currentpassword = "";
      this.cPassword = "";
      this.password = "";
      }
    }
  }
};
</script>

<style scoped>
.company {
  width: 147px;
  height: 147px;
  border-radius: 100px;
}
.regnext_btn {
  width: 100%;
  height: 56px;
  font-weight: bold;
  font-size: 1rem;
}
.pman {
  width: auto;
  margin-top: 70px;
}

.slide_options {
  background-color: #f8fafa;
  border-radius: 30px;
  margin: 10px 0px;
  margin-top: 44px;
  padding: 5px 0px;
}

.slide_item {
  text-align: center;
  padding: 18px;
  cursor: pointer;
}

.spressed {
  text-align: center;
  padding: 18px;
  border-radius: 30px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px 0 rgba(40, 60, 80, 0.12);
}

.slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #b4bec8;
}

.spressed .slide_txt {
  font-size: 1rem;
  font-weight: bold;
  color: #3d7dd8;
}

.pview {
  margin-top: 38.5px;
  margin-bottom: 80px;
}

.avatar {
  width: 80%;
  border-radius: 100px;
}

.pgraytxt {
  opacity: 0.64;
  font-size: 1rem;
  font-weight: 500;
}

.cs_summary {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1.5;
  margin-top: 21px;
}

.pvlabel {
  margin-left: 20px;
}

.pv_btnpanel {
  padding: 0px 10%;
}

.updatebtn {
  width: 100%;
  height: 56px;
}

.pv_showchart {
  background-color: #f8f8fa;
  margin-top: 16px;
}

.eview {
  padding: 30px 15px;
}

.chartboxes {
  display: block;
  margin: auto;
  margin-bottom: 30px;
  max-width: 200px;
  height: 100px;
}

.statustitle {
  font-size: 1.25rem;
  font-weight: bold;
  margin-top: 34px;
  margin-bottom: 0.1rem;
}

.statusnum {
  position: absolute;
  /*right: 46%;
      top: 55%;*/
  font-weight: bold;
  font-size: 1.5rem;
}

.caltxt {
  margin-top: 45px;
}

.calpanel {
  text-align: right;
}

.camera {
  box-shadow: 0 2px 4px 0 rgba(40, 60, 80, 0.12);
  background-color: #ffffff;
  border: solid 1px #c8d2dc;
  border-radius: 100px;
  padding: 8px 9px;
  position: absolute;
  top: 105px;
  right: 30px;
  cursor: pointer;
}

.camera:hover {
  background-color: #3d7dd8;
}

.camera:hover .fa-camera {
  color: white;
}

.camera .fa-camera {
  font-size: 20px;
  color: #3d7dd8;
}

.peditlabel {
  font-size: 1rem;
  font-weight: 500;
  margin-left: 20px;
  margin-top: 20px;
}

.peditinput {
  width: 100%;
  height: 44px;
  padding: 0px 16px;
  margin-left: 20px;
}

.pedittextarea {
  width: 100%;
  height: 188px;
  padding: 16px;
  margin-left: 20px;
}

.peselectboxs {
  float: left;
  margin-left: 20px;
}

.selectdiv select {
  height: 50px !important;
}

.peradioboxs {
  text-align: center;
  min-width: 128px;
  height: 50px;
  float: left;
  background-color: #ffffff;
  border: 1px solid #b4bec8;
  color: #b4bec8;
  margin-left: 20px;
  margin-top: 5px;
  padding-top: 10px;
  border-radius: 4px;
  cursor: pointer;
}

.manradio:hover,
.mchosen {
  border: 1px solid #3d7dd8;
  color: #3d7dd8;
}

.womenradio:hover,
.wchosen {
  border: 1px solid #f878c8;
  color: #f878c8;
}
.peradiotxt {
  font-size: 0.875rem;
  font-weight: bold;
}
.input input:focus select:focus {
  outline: none;
  border: 1px solid #3d7dd8;
  background-color: #eee;
}

.input.invalid label {
  color: red;
}

.input.invalid input {
  border: 1px solid red;
  background-color: #ffc9aa;
}
.linput {
  width: 423px;
}

.form-group {
  margin-bottom: 0px;
}

.upload-btn-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
}

.upload-btn-wrapper input[type="file"] {
  font-size: 100px;
  position: absolute;
  top: 105px;
  right: 30px;
  opacity: 0;
}

@media screen and (max-width: 1200px) {
  .camera {
    top: 80px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80px;
    right: 20px;
  }
}

@media screen and (max-width: 992px) {
  .camera {
    top: 50px;
    right: 20px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 50px;
    right: 20px;
  }

  .linput {
    width: 100%;
  }
}

@media screen and (max-width: 768px) {
  .pman {
    margin-top: 0px;
  }

  .avatar {
    width: 50%;
  }

  .page_title {
    margin-top: 40px;
  }

  .pvlabel {
    margin-left: 0px;
  }

  .calpanel {
    text-align: center;
  }

  .camera {
    top: 80%;
    right: 20%;
  }

  .peditlabel {
    margin-left: 0px;
  }

  .peditinput {
    margin-left: 0px;
  }

  .pedittextarea {
    margin-left: 0px;
  }

  .peselectboxs {
    width: 100%;
    margin-left: 0px;
  }

  .peradioboxs {
    width: 100%;
    margin-left: 0px;
  }

  .help-block {
    margin-left: 0px;
    margin-top: 10px;
  }

  .upload-btn-wrapper input[type="file"] {
    top: 80%;
    right: 20%;
  }
}
</style>